/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as CancelIcon } from '../../assets/images/cancel_24px.svg';
import { ReactComponent as SearchIcon } from '../../assets/images/searchIcon.svg';
import { t } from '../../providers';

const useStyles = makeStyles((theme) => ({
    searchInput: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        '@media (max-width:960px)': {
            flexWrap: 'wrap',
        },
    },
    searchLabel: {
        fontSize: '14px',
        fontWeight: '600',
        color: theme.palette.text.tableValue,
        marginRight: '6px',
        '@media (max-width:600px)': {
            display: 'none',
        },
    },
    textInput: {
        height: '2rem',
        width: '14rem',
        border: 'none',
        background: '#F1F2F5',
        '& input': {
            '&::placeholder': {
                paddingLeft: '10px',
                opacity: '1',
                color: '#6B6C7E',
                fontSize: '16px',
            },
        },
        '@media (max-width:600px)': {
            width: '12.5rem',
        },
    },
    searchButton: {
        height: 'auto',
        minWidth: '4.5rem',
        color: theme.palette.text.mainBlue + '!important', //
        border: '1px solid' + theme.palette.text.mainBlue,
    },
    disabledSearch: {
        cursor: 'not-allowed',
    },
    searchIcon: {
        pointerEvents: 'none',
    },
}));

const SearchFilter = ({ onSearch, searchQuery, onClear }) => {
    const classes = useStyles();

    const [search, setSearch] = useState('');

    useEffect(() => {
        setSearch(searchQuery);
    }, [searchQuery]);

    const handleSearchChange = (event) => {
        if (searchQuery && search.length >= 1 && event.target.value.length === 0) {
            onClear();
        }
        setSearch(event.target.value);
    };

    const doSearch = () => onSearch(search);

    const onClearSearch = () => {
        setSearch('');
        if (searchQuery) onClear();
    };

    return (
        <div className={classes.searchInput}>
            <InputLabel htmlFor="search" className={classes.searchLabel}>
                {t('search')}:
            </InputLabel>
            <Input
                id="search"
                className={classes.textInput}
                placeholder={t('search')}
                type="input"
                name="search"
                fullWidth
                required
                endAdornment={
                    <InputAdornment position="end">
                        {!search ? (
                            <IconButton className={classes.searchIcon}>
                                <SearchIcon />
                            </IconButton>
                        ) : (
                            <IconButton id={'cancelButton'} onClick={onClearSearch}>
                                <CancelIcon />
                            </IconButton>
                        )}
                    </InputAdornment>
                }
                onChange={handleSearchChange}
                value={search}
            />
            <Button
                aria-label="toggle password visibility"
                id={'searchButton'}
                onClick={doSearch}
                className={[classes.searchButton, search.length < 3 ? classes.disabledSearch : ''].join(' ')}
                disableRipple
                disableFocusRipple>
                {t('search.button')}
            </Button>
        </div>
    );
};

export default SearchFilter;
